import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { SuccessDescription } from 'components/ui/AuthSuccess/components/ui/SuccessDescription';
import { TAuthSuccessVariant } from 'components/ui/AuthSuccess/types/auth-success-variant.type';
import { AppRoute } from 'utils/route/app-route';

export const useAuthSuccessAttributes = (
  variant: TAuthSuccessVariant,
  isTrial: boolean,
): {
  title: string;
  descriptionContent: ReactElement | null;
  linkText: string;
  linkUrl: string;
} => {
  const { t } = useTranslation();

  let title = '';
  let descriptionContent = null;
  let linkText = '';
  let linkUrl = '';

  switch (variant) {
    case 'password-reset':
      title = t('registration.newPasswordIsSet');
      descriptionContent = <SuccessDescription t={t} variant={'password-reset'} />;
      linkText = t('loginForm.logIn');
      linkUrl = AppRoute.Login();
      break;
    case 'registration':
      title = t('registration.successfulRegistration');
      descriptionContent = <SuccessDescription t={t} variant={'registration'} />;
      linkText = isTrial ? t('registration.buyTrialMiner') : t('registration.goToDashboard');
      linkUrl = AppRoute.Home();
      break;
  }

  return { title, descriptionContent, linkText, linkUrl };
};
